import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { FormattedDate, FormattedCalendarDate } from 'components/Formatters';
import { WarningAlert } from 'components/Alerts';

export interface ScheduledPaymentCreditCardExpiredProps {
  paymentDueDate: string | Date;
  cardType: string;
  lastFourDigits: string;
  updatePaymentMethodUrl: string;
}

export const ScheduledPaymentCreditCardExpired = (props: ScheduledPaymentCreditCardExpiredProps) => (
  <WarningAlert>
    <WarningAlert.Heading>
      Please update your payment details before <FormattedCalendarDate date={props.paymentDueDate} />, or your booking will be cancelled.
    </WarningAlert.Heading>
    <WarningAlert.Body>
      Your {props.cardType} credit card ending {props.lastFourDigits} has expired and we are unable to take final payment. To avoid your
      booking being cancelled, please update your payment details before{' '}
      <strong>
        <FormattedDate date={props.paymentDueDate} />
      </strong>
      .
    </WarningAlert.Body>
    <WarningAlert.Link
      data-testid="scheduled-payment-alert-update-credit-card-link"
      to={props.updatePaymentMethodUrl}
      onClick={tracking.scheduledPaymentCreditCardExpiredUpdateCreditCard}
    >
      UPDATE CREDIT CARD
    </WarningAlert.Link>
  </WarningAlert>
);
